const InfoSection = ({ icon, title, children }) => (
  <div className="flex flex-col items-start justify-start self-stretch shrink-0">
    <div className="flex flex-row items-center justify-start shrink-0">
      {icon}
      <div className="text-gray-700 Body1-16Bd ml-[4px]">{title}</div>
    </div>
    <div className="text-gray-600 Body2-14Md self-stretch mt-[8px]">{children}</div>
  </div>
)

export default InfoSection
